module.exports = __webpack_public_path__ + "fonts/nunito-sans-latin-900.a33ed98.woff";